import { APPLICATION, IMAGE, VIDEO } from 'consts';

export const getFileKind = (type: string) => {
  const typeMap = new Map([
    ['application/pdf', APPLICATION],
    ['application/msword', APPLICATION],
    ['application/vnd.openxmlformats-officedocument.wordprocessingml.document', APPLICATION],
    ['image/png', IMAGE],
    ['image/jpeg', IMAGE],
    ['video/mp4', VIDEO],
  ]);

  return typeMap.get(type);
};
